import getDayjsInstance from './getDayjsInstance';

const blockBeforeCurrentDateAfterYear = () =>
  getDayjsInstance().format('YYYY-MM-DD');

export default blockBeforeCurrentDateAfterYear;
